// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"4b237070","165":"54972e08","186":"ccbfcad0","308":"7bf6b1a9","406":"c3706c84","487":"2acef2cc","488":"e70c806c","559":"b809c164","747":"b0ade758","880":"558df008","938":"607e345b","992":"bf2ff9fa"}[chunkId] + ".chunk.js";
};